module.exports = __webpack_public_path__ + "img/cpi-logo.bca3cd09.png";